module.exports = __webpack_public_path__ + "static/media/ned.a5e3dfcb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Pictures/pics/ned.jpeg
// module id = 141
// module chunks = 0